import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notification } from 'antd';

import { DOMAIN_HIERARCHY_LIMIT, NOTIFICATION_MESSAGES } from '@/shared/lib/constants';
import { assetKeys, discoveryKeys, domainKeys } from '@/shared/lib/query/queryKeys';

import { updateDomainApi } from '@/features/domain/api/updateDomainApi';
import type { UpdateDomainRequest } from '@/features/domain/api/updateDomainApi';

export const useUpdateDomain = (domainFqn?: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (request: UpdateDomainRequest) => updateDomainApi(request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: domainKeys.hierarchy(DOMAIN_HIERARCHY_LIMIT) });
      queryClient.invalidateQueries({ queryKey: domainKeys.domainTree });
      queryClient.invalidateQueries({ queryKey: domainKeys.subDomainsPrefix() });

      if (domainFqn) {
        queryClient.invalidateQueries({ queryKey: domainKeys.detail(domainFqn) });
      }

      queryClient.invalidateQueries({ queryKey: assetKeys.assetBaseInfoPrefix() });
      queryClient.invalidateQueries({ queryKey: assetKeys.dataAssetsPrefix() });
      queryClient.invalidateQueries({ queryKey: assetKeys.schemaPrefix() });
      queryClient.invalidateQueries({ queryKey: discoveryKeys.searchPrefix() });
      queryClient.invalidateQueries({ queryKey: assetKeys.lineagePrefix() });

      notification.success({
        message: NOTIFICATION_MESSAGES.DOMAIN_UPDATE_SUCCESS,
        description: NOTIFICATION_MESSAGES.DOMAIN_UPDATE_SUCCESS_DESC,
        placement: 'bottomLeft',
        duration: 3,
      });
    },
  });
};
